import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {PageSectionType} from '../../common/model/page/page-section.model';
import {PageScrollInstance, PageScrollService} from 'ngx-page-scroll';
@Injectable()
export class ViewScrollService {
  constructor(private pageScrollService: PageScrollService,
              @Inject(DOCUMENT) private document) {
  }

  scrollToSection (section: PageSectionType) {
    const pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, section);
    this.pageScrollService.start(pageScrollInstance);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/view-scroll.service.ts